import React, { useState } from 'react';
import { ScrollReveal } from '../components/ui/ScrollReveal';
import { BrandButton } from '../components/ui/BrandButton';
import { MailIcon, InstagramIcon, Music2Icon, SendIcon } from 'lucide-react';
export function ContactPage() {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: 'General Inquiry',
    message: ''
  });
  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement | HTMLTextAreaElement>) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
  };
  const inputStyles = 'w-full h-[44px] px-4 rounded-xl border border-[#F8C8DC] bg-white font-body text-[#2D1A1A] placeholder:text-[#2D1A1A]/40 focus:outline-none focus:ring-2 focus:ring-[#6B1D4A] focus:border-[#6B1D4A] transition-colors';
  return <div className="flex flex-col w-full bg-[#FFF8F0]" data-id="element-271">
      {/* Hero */}
      <section className="pt-32 pb-16 bg-gradient-to-b from-[#F8C8DC] to-[#FFF8F0] text-center px-4" data-id="element-272">
        <ScrollReveal data-id="element-273">
          <h1 className="font-heading text-5xl md:text-6xl font-bold text-[#2D1A1A] mb-4" data-id="element-274">
            Let's Chat
          </h1>
          <p className="font-script text-2xl md:text-3xl text-[#6B1D4A] max-w-2xl mx-auto" data-id="element-275">
            Wholesale inquiries, collabs, or just want to say hey — we'd love to
            hear from you.
          </p>
        </ScrollReveal>
      </section>

      {/* Form + Side Info */}
      <section className="py-16 md:py-24 bg-[#FFF8F0]" data-id="element-276">
        <div className="container mx-auto px-4 md:px-8" data-id="element-277">
          <div className="flex flex-col md:flex-row gap-12 md:gap-16 max-w-5xl mx-auto" data-id="element-278">
            {/* Contact Form */}
            <div className="w-full md:w-3/5" data-id="element-279">
              <ScrollReveal direction="up" delay={100} data-id="element-280">
                <form onSubmit={handleSubmit} className="bg-white rounded-2xl shadow-lg p-8 md:p-10 border border-[#F8C8DC]/50" data-id="element-281">
                  <div className="space-y-5" data-id="element-282">
                    <div data-id="element-283">
                      <label htmlFor="name" className="block font-body font-medium text-[#2D1A1A] mb-2 text-sm" data-id="element-284">
                        Name
                      </label>
                      <input type="text" id="name" name="name" value={formData.name} onChange={handleChange} placeholder="Your name" className={inputStyles} required data-id="element-285" />
                    </div>

                    <div data-id="element-286">
                      <label htmlFor="email" className="block font-body font-medium text-[#2D1A1A] mb-2 text-sm" data-id="element-287">
                        Email
                      </label>
                      <input type="email" id="email" name="email" value={formData.email} onChange={handleChange} placeholder="you@email.com" className={inputStyles} required data-id="element-288" />
                    </div>

                    <div data-id="element-289">
                      <label htmlFor="subject" className="block font-body font-medium text-[#2D1A1A] mb-2 text-sm" data-id="element-290">
                        Subject
                      </label>
                      <select id="subject" name="subject" value={formData.subject} onChange={handleChange} className={`${inputStyles} appearance-none bg-[url('data:image/svg+xml;charset=UTF-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%2212%22%20height%3D%2212%22%20viewBox%3D%220%200%2012%2012%22%3E%3Cpath%20fill%3D%22%236B1D4A%22%20d%3D%22M6%208L1%203h10z%22%2F%3E%3C%2Fsvg%3E')] bg-no-repeat bg-[right_1rem_center]`} data-id="element-291">
                        <option data-id="element-292">General Inquiry</option>
                        <option data-id="element-293">Wholesale / Bulk Orders</option>
                        <option data-id="element-294">Collaboration</option>
                        <option data-id="element-295">Press</option>
                        <option data-id="element-296">Other</option>
                      </select>
                    </div>

                    <div data-id="element-297">
                      <label htmlFor="message" className="block font-body font-medium text-[#2D1A1A] mb-2 text-sm" data-id="element-298">
                        Message
                      </label>
                      <textarea id="message" name="message" value={formData.message} onChange={handleChange} placeholder="Tell us what's on your mind..." rows={4} className="w-full px-4 py-3 rounded-xl border border-[#F8C8DC] bg-white font-body text-[#2D1A1A] placeholder:text-[#2D1A1A]/40 focus:outline-none focus:ring-2 focus:ring-[#6B1D4A] focus:border-[#6B1D4A] transition-colors resize-none" required data-id="element-299" />
                    </div>

                    <button type="submit" className="w-full sm:w-auto inline-flex items-center justify-center gap-2 rounded-full px-10 py-3 min-h-[48px] bg-[#E91E8C] text-white font-body font-medium hover:bg-[#C21472] transition-colors shadow-sm hover:shadow-md" data-id="element-300">
                      <SendIcon className="w-4 h-4" data-id="element-301" />
                      Send It
                    </button>
                  </div>

                  <p className="font-body text-sm text-[#2D1A1A]/50 mt-6" data-id="element-302">
                    We typically respond within 24–48 hours
                  </p>
                </form>
              </ScrollReveal>
            </div>

            {/* Side Info */}
            <div className="w-full md:w-2/5" data-id="element-303">
              <ScrollReveal direction="up" delay={300} data-id="element-304">
                <div className="sticky top-32" data-id="element-305">
                  <h3 className="font-heading text-2xl font-bold text-[#2D1A1A] mb-8" data-id="element-306">
                    Other ways to reach us
                  </h3>

                  <div className="space-y-6" data-id="element-307">
                    <a href="mailto:hello@butter-blonde.com" className="flex items-center gap-4 group" data-id="element-308">
                      <div className="w-12 h-12 rounded-full bg-[#F8C8DC] flex items-center justify-center text-[#6B1D4A] group-hover:bg-[#E91E8C] group-hover:text-white transition-colors shrink-0" data-id="element-309">
                        <MailIcon className="w-5 h-5" data-id="element-310" />
                      </div>
                      <div data-id="element-311">
                        <p className="font-body font-medium text-[#2D1A1A] group-hover:text-[#E91E8C] transition-colors" data-id="element-312">
                          hello@butter-blonde.com
                        </p>
                        <p className="font-body text-sm text-[#2D1A1A]/50" data-id="element-313">
                          Email us
                        </p>
                      </div>
                    </a>

                    <a href="https://instagram.com/butterblonde" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 group" data-id="element-314">
                      <div className="w-12 h-12 rounded-full bg-[#F8C8DC] flex items-center justify-center text-[#6B1D4A] group-hover:bg-[#E91E8C] group-hover:text-white transition-colors shrink-0" data-id="element-315">
                        <InstagramIcon className="w-5 h-5" data-id="element-316" />
                      </div>
                      <div data-id="element-317">
                        <p className="font-body font-medium text-[#2D1A1A] group-hover:text-[#E91E8C] transition-colors" data-id="element-318">
                          @butterblonde
                        </p>
                        <p className="font-body text-sm text-[#2D1A1A]/50" data-id="element-319">
                          Instagram
                        </p>
                      </div>
                    </a>

                    <a href="https://tiktok.com/@butterblonde" target="_blank" rel="noopener noreferrer" className="flex items-center gap-4 group" data-id="element-320">
                      <div className="w-12 h-12 rounded-full bg-[#F8C8DC] flex items-center justify-center text-[#6B1D4A] group-hover:bg-[#E91E8C] group-hover:text-white transition-colors shrink-0" data-id="element-321">
                        <Music2Icon className="w-5 h-5" data-id="element-322" />
                      </div>
                      <div data-id="element-323">
                        <p className="font-body font-medium text-[#2D1A1A] group-hover:text-[#E91E8C] transition-colors" data-id="element-324">
                          @butterblonde
                        </p>
                        <p className="font-body text-sm text-[#2D1A1A]/50" data-id="element-325">
                          TikTok
                        </p>
                      </div>
                    </a>
                  </div>

                  <div className="mt-10 p-6 bg-[#F8C8DC]/20 rounded-2xl border border-[#F8C8DC]" data-id="element-326">
                    <p className="font-body text-[#6B1D4A] text-sm leading-relaxed" data-id="element-327">
                      <span className="font-bold" data-id="element-328">Wholesale?</span> Mention your
                      business name and we'll send over our lookbook.
                    </p>
                  </div>
                </div>
              </ScrollReveal>
            </div>
          </div>
        </div>
      </section>

      {/* Bottom CTA Banner */}
      <section className="py-20 md:py-24" style={{
      background: 'repeating-linear-gradient(90deg, #F5D76E 0px, #F5D76E 20px, #F0CC50 20px, #F0CC50 40px)'
    }} data-id="element-329">
        <div className="container mx-auto px-4 text-center" data-id="element-330">
          <ScrollReveal data-id="element-331">
            <h2 className="font-heading text-3xl md:text-4xl font-bold text-[#2D1A1A] mb-8" data-id="element-332">
              Rather just shop?
            </h2>
            <BrandButton href="/collections" variant="outline" className="text-lg px-12" data-id="element-333">
              Browse Collections
            </BrandButton>
          </ScrollReveal>
        </div>
      </section>
    </div>;
}